import { ButtonProps } from '@shared/ui/kit/button/model/types';
import { forwardRef, ReactNode } from 'react';

import stylex from '@stylexjs/stylex';
import { styles } from './styles.ts';

interface IIconProps extends Omit<ButtonProps, 'children'> {
  icon?: ReactNode;
  children?: ReactNode;
  iconPosition?: 'left' | 'right';
  size?: 'small' | 'medium';
}

export const IconButton = forwardRef<HTMLButtonElement, IIconProps>(
  ({ icon, children, iconPosition = 'left', size = 'medium', onClick, ...rest }, ref) => {
    return (
      <button
        ref={ref}
        onClick={onClick}
        {...stylex.props(styles.button, size === 'small' && styles.buttonSmall)}
        {...rest}
      >
        {iconPosition === 'left' && icon}
        {children}
        {iconPosition === 'right' && icon}
      </button>
    );
  }
);
